module.exports = __webpack_public_path__ + "img/zf_icon03-6873da.png";